import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';

const IconButton = ({ className, id, children, onClick, ...otherProps }) => {
  const {
    'aria-controls': ariaControls,
    'aria-expanded': ariaExpanded,
    'aria-label': ariaLabel,
  } = otherProps;

  return (
    <button
      className={classNames('IconButton', className)}
      {...(ariaControls ? { 'aria-controls': ariaControls } : {})}
      {...(ariaExpanded ? { 'aria-expanded': String(ariaExpanded) } : {})}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
      {...(onClick ? { onClick } : {})}
      {...(id ? { id } : {})}
    >
      {children}
      <style jsx>{`
        .IconButton {
          display: flex;
          justify-content: center;
          align-items: center;
          min-width: ${Theme.get('touch-target-size-px')};
          min-height: ${Theme.get('touch-target-size-px')};
          outline: 0;
          background-color: transparent;
          border: 0;
          cursor: pointer;
          padding: 0;
          appearance: none;
        }

        .IconButton.focused {
          outline: 2px solid ${Theme.get('colors-black')};
        }
      `}</style>
    </button>
  );
};

IconButton.propTypes = {
  'aria-controls': PropTypes.string,
  'aria-expanded': PropTypes.bool,
  'aria-label': PropTypes.string,
  id: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

IconButton.defaultProps = {
  'aria-controls': null,
  'aria-expanded': null,
  'aria-label': null,
  id: null,
  className: '',
};

export default IconButton;
